<template>
  <div class="menuBox">
    <Slide noOverlay class="slideMenu" width="200">
      <router-link to="/" tag="li">
        <v-fa :icon="['fas', 'paw']" class="flex items-center" />
        　Top
      </router-link>
      <router-link to="/about" tag="li">
        <v-fa :icon="['far', 'smile']" class="flex items-center" />
        　About me
      </router-link>
      <!-- <router-link to="/pictures" tag="li">
        Pictures
      </router-link> -->
      <router-link to="/research" tag="li">
        <v-fa :icon="['fas', 'search']" class="flex items-center" />
        　Research
      </router-link>
    </Slide>
  </div>
</template>

<script>
  import {
    Slide
  } from 'vue-burger-menu'
  export default {
    components: {
      Slide
    }
  }
</script>

<style lang="postcss" scoped>
  /* .menuBox {
    position: fixed;
    left: -17px;
    top: 40px;
    z-index: 100;
  }

  .bm-burger-button {
    top: 0;
  }

  .bm-item-list {
    position: relative;
    width: 100%;
    color: #b8b7ad;
    left: -17px;
    margin-top: 20px;
    font-size: 20px;
    cursor: pointer;
  }

  .bm-item-list>*:hover {
    background-color: #c67b66;
  } */
  li:hover {
    background-color: #b37373;
  }

  .svg-inline--fa{
    height: auto;
  }
</style>